import { doc, setDoc, writeBatch } from 'firebase/firestore';
import { db } from './firebase';
import { defaultAddons, defaultFaqs, defaultGallery, defaultPackages, defaultServices, defaultSettings } from './defaults';

/**
 * Writes the built-in starter content into Firestore so it becomes live,
 * editable data. Safe to run more than once (overwrites the starter docs
 * by their fixed ids, leaves everything else untouched). Testimonials are
 * intentionally NOT seeded — real reviews only.
 */
export async function seedFirestore() {
  const batch = writeBatch(db());
  for (const { id, ...data } of defaultPackages) batch.set(doc(db(), 'packages', id), data);
  for (const { id, ...data } of defaultAddons) batch.set(doc(db(), 'addons', id), data);
  for (const { id, ...data } of defaultServices) batch.set(doc(db(), 'customServices', id), data);
  for (const { id, ...data } of defaultFaqs) batch.set(doc(db(), 'faqs', id), data);
  for (const { id, ...data } of defaultGallery) batch.set(doc(db(), 'gallery', id), data);
  await batch.commit();
  await setDoc(doc(db(), 'settings', 'site'), defaultSettings, { merge: true });
}
